var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuesSales(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4082 11.4127L12.5782 2.58269C12.2082 2.21269 11.6982 2.00269 11.1682 2.00269H3.99817C2.89817 2.00269 1.99817 2.90269 1.99817 4.00269V11.1727C1.99817 11.7027 2.20817 12.2127 2.58817 12.5827L11.4182 21.4127C12.1982 22.1927 13.4682 22.1927 14.2482 21.4127L21.4182 14.2427C22.1982 13.4627 22.1982 12.2027 21.4082 11.4127ZM12.8282 20.0027L3.99817 11.1727V4.00269H11.1682L19.9982 12.8327L12.8282 20.0027Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.49817 8.00269C7.3266 8.00269 7.99817 7.33111 7.99817 6.50269C7.99817 5.67426 7.3266 5.00269 6.49817 5.00269C5.66974 5.00269 4.99817 5.67426 4.99817 6.50269C4.99817 7.33111 5.66974 8.00269 6.49817 8.00269Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuesSales);
export default __webpack_public_path__ + "static/media/MenuesSales.04e3e951417edfc0689adb4d774491c6.svg";
export { ForwardRef as ReactComponent };